export const setCookie = (value, cookieName) => {
  document.cookie = `${cookieName}=${value}; expires=${new Date(
    new Date().getTime() + 365 * 24 * 60 * 60 * 1000
  ).toUTCString()}; domain=${LOGIN_HINTS_COOKIE_DOMAIN}; path=/; secure`;
};

export const deleteCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=${LOGIN_HINTS_COOKIE_DOMAIN}; path=/`;
};
